import PropTypes from 'prop-types'
import React from 'react'

import { Caption1 } from '@thebeansgroup/sb_ui/typography'
import Colours from '@thebeansgroup/ui_style_helpers/colours'

import { consumerGroupIsNotGraduate } from '@src/helpers'

import { canRenderAction } from './helpers'
import styles from './styles'

function InputError({
  error,
  errorActionText,
  handleErrorAction,
  consumerGroup
}) {
  const renderAction = () => {
    if (!canRenderAction(handleErrorAction, errorActionText)) return

    return (
      <a
        style={styles.action}
        onClick={handleErrorAction}
      >
        {errorActionText}
      </a>
    )
  }

  const giveStyles = () => {
    if (!consumerGroupIsNotGraduate(consumerGroup)) {
      return styles.nonAbsolute
    }

    return styles.base
  }

  return (
    <div
      style={giveStyles()}
      data-testid='input-alert'
    >
      <Caption1 colour={Colours('alertRed', '300')}>
        {error}
        &nbsp;
        {renderAction()}
      </Caption1>
    </div>
  )
}

InputError.defaultProps = {
  consumerGroup: 'student'
}

InputError.propTypes = {
  error: PropTypes.string.isRequired,
  errorActionText: PropTypes.string,
  handleErrorAction: PropTypes.func,
  consumerGroup: PropTypes.string
}

export default InputError
